/* eslint-disable jsx-a11y/control-has-associated-label */
import { useEffect, useState } from 'react';
import {
  CardHeader,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  FormGroup,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
  ModalBody,
  ModalFooter,
  Form,
  Container,
  Badge,
} from 'reactstrap';
import api from 'services/api';
import Swal from 'sweetalert2';
import {
  FaCheck,
  FaEdit,
  FaEraser,
  FaHistory,
  FaPlusCircle,
  FaSearch,
  FaTrash,
} from 'react-icons/fa';
import Select from 'react-select';
import {
  Checkbox,
  CircularProgress,
  TextField,
  Tooltip,
} from '@material-ui/core';
import toast from 'react-hot-toast';
import { RegraPerdaEspecificaItem } from 'models/RegraPerdaEspecificaItem';
import UserSmallHeader from 'components/Headers/UserSmallHeader';
import AutocompleteItem, {
  iAutoCompleteItem,
} from 'components/AutocompleteItem';
import Header from 'components/Headers/Header';
import Item from 'antd/lib/list/Item';
import FloatingButton from 'components/FloatingButton';
import { AutoSizer, Column, Table } from 'react-virtualized';
import { Th, Td } from './styles';

interface iTipo {
  id: string;
  descricao: string;
  podeDispararManualmente: boolean;
  obrigaCodigo: boolean;
}

interface iLog {
  id: number;
  detalhe: string;
  createdAt: any;
  possui: boolean;
  objeto: any;
}

interface iIntegracao {
  id: number;
  seq: number;
  isConcluido: boolean;
  isEnviado: boolean;
  isErro: boolean;
  log: string;
  tipo: string;
  updatedAt: any;
  createdAt: any;
  usuarioId?: number;
  origem: string;
  destino: string;
  tipoNotificacao: iTipo;
  custom1?: string;
  custom2?: string;
  custom3?: string;
  status: string;
  checked: boolean | false;
}

interface iFiltros {
  status?: string;
  tipo?: string;
  dataInicio?: string;
  dataFim?: string;
}

interface iNovaIntegracao {
  tipo?: string;
  origem?: string;
}

export default function Integracao(): JSX.Element {
  const [tipos, setTipos] = useState<iTipo[]>([]);
  const [registros, setRegistros] = useState<iIntegracao[]>([]);
  const [logs, setLogs] = useState<iLog[]>([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLogVisivel, setModalLogVisivel] = useState(false);
  const [registroLog, setRegistroLog] = useState<iIntegracao>(
    {} as iIntegracao,
  );
  const [selectAll, setSelectAll] = useState(false);

  const [novaIntegracao, setNovaIntegracao] = useState<iNovaIntegracao>(
    {} as iNovaIntegracao,
  );

  const getFormattedDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Inside your component, replace the current state declarations with:
  const today = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);

  const [filtros, setFiltros] = useState<iFiltros>({
    status: '',
    tipo: '',
    dataInicio: getFormattedDate(thirtyDaysAgo),
    dataFim: getFormattedDate(today),
  } as iFiltros);

  const status = [
    {
      id: 'S',
      descricao: 'Sucesso',
      color: 'success',
    },
    {
      id: 'P',
      descricao: 'Pendente',
      color: 'info',
    },
    {
      id: 'A',
      descricao: 'Andamento',
      color: 'warning',
    },
    {
      id: 'E',
      descricao: 'Erro',
      color: 'danger',
    },
  ];

  async function buscarTipos(): Promise<void> {
    try {
      setIsLoading(true);
      const response = await api.get(`/integracao-sap/tipos`);
      const lista = response.data;
      setTipos(lista);
    } finally {
      setIsLoading(false);
    }
  }

  async function buscarDados(fil: iFiltros): Promise<void> {
    try {
      if (!fil.dataInicio || !fil.dataFim) {
        toast.error('As datas devem ser informadas');
        return;
      }
      setIsLoading(true);
      const response = await api.get(
        `/integracao-sap?status=${fil.status}&tipo=${fil.tipo}&dataInicio=${fil.dataInicio}&dataFim=${fil.dataFim}`,
      );
      const lista = response.data;

      setRegistros(lista);
    } finally {
      setIsLoading(false);
    }
  }

  async function buscarLog(id: number): Promise<void> {
    try {
      setLogs([]);
      setIsLoading(true);
      const response = await api.get(`/integracao-sap/${id}/logs`);
      const lista = response.data;
      console.log(lista);

      setLogs(lista);
    } finally {
      setIsLoading(false);
    }
  }

  async function limparFiltros() {
    setFiltros({
      status: '',
      tipo: '',
      dataInicio: getFormattedDate(thirtyDaysAgo),
      dataFim: getFormattedDate(today),
    } as iFiltros);
    buscarDados({
      status: '',
      tipo: '',
      dataInicio: getFormattedDate(thirtyDaysAgo),
      dataFim: getFormattedDate(today),
    } as iFiltros);
  }

  async function salvar() {
    const { tipo, origem } = novaIntegracao;

    if (!tipo) {
      toast.error('O tipo deve ser informado');
      return;
    }

    const tipoObrigaCodigo =
      tipos.find(item => item.id === tipo)?.obrigaCodigo ?? false;

    if (tipoObrigaCodigo && !origem) {
      toast.error(
        'O tipo selecionado obriga o preenchimento de um código de referência',
      );
      return;
    }

    const data = {
      tipo,
      origem,
    };

    try {
      setIsSaving(true);

      await api.post(`/integracao-sap`, data);

      await buscarDados(filtros);

      toast.success('Integração criada');

      setIsModalOpen(false);
    } finally {
      setIsSaving(false);
    }
  }

  useEffect(() => {
    buscarTipos();
    limparFiltros();
  }, []);

  async function mostrarModalLog(item: iIntegracao) {
    await buscarLog(item.id);
    setRegistroLog(item);
    setModalLogVisivel(true);
  }

  async function handleOpenModal() {
    setNovaIntegracao({
      origem: '',
      tipo: '',
    });
    setIsModalOpen(true);
  }

  async function handleProcessarManualmente() {
    const result = await Swal.fire({
      icon: 'warning',
      html: `
          <h1>Atenção</h1>
          <p>Foram marcados ${
            registros.filter(item => item.checked === true).length
          } registros para integrar. O processo pode demorar. Deseja prosseguir?</p>`,
      width: '400px',
      allowOutsideClick: false,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: `Sim, integrar`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Cancelar`,
    });

    if (result.isConfirmed) {
      try {
        Swal.fire({
          icon: 'info',
          text: `Integrando`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });
        const retorno = await api.post(`/integracao-sap/executar`, {
          registros: registros
            .filter(item => item.checked === true)
            .map(item => item.id),
        });

        const confirmacao = await Swal.fire({
          icon: 'info',
          html: `<div>
          <p>O processo de integração foi disparado e está executando.</p>
          <small>Dependendo da quantidade de dados o processo pode demorar. A integração ficará em status "Andamento" até ser concluída. Aguarde e atualize a lista.</small>
          </div>`,
          allowOutsideClick: false,
          showConfirmButton: true,
        });
      } catch (error: any) {
        const er = await Swal.fire({
          icon: 'error',
          title: 'Ops!',
          text: error?.response?.data?.message,
        });
        throw error;
      } finally {
        await buscarDados(filtros);
      }
    }
  }

  async function handleLoadJson(id: number) {
    const retorno = await api.get(`/integracao-sap/logs/${id}`, {});
    const log = retorno.data ?? '{}';

    Swal.fire({
      icon: 'info',
      html: ` <pre style={{
  maxHeight: '70vh',
  overflow: 'auto',
  background: '#1e1e1e',
  color: '#d4d4d4',
  padding: 16,
  borderRadius: 8
}}>
  <div style='height: 75px; overflow-y: scroll;'>${JSON.stringify(
    log.objeto,
  )}<div></pre>`,
      allowOutsideClick: true,
      showConfirmButton: true,
    });
  }

  function DetalharLog(): JSX.Element {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress className="mt-2 ml-2" color="inherit" size={20} />
        </div>
      );
    }

    if (logs.length) {
      return (
        <>
          {logs.map(log => {
            const dataGeracao = new Intl.DateTimeFormat('pt-BR', {
              dateStyle: 'long',
              timeStyle: 'medium',
            }).format(new Date(log.createdAt));
            return (
              <>
                <div
                  className="timeline timeline-one-side"
                  data-timeline-axis-style="dashed"
                  data-timeline-content="axis"
                >
                  <div className="timeline-block">
                    <div className="timeline-content my-2">
                      <Row>
                        <small className="font-weight-bold ml-3 mt-3">
                          #{log.id} em {dataGeracao}
                        </small>
                      </Row>
                      <p className="text-sm my-2">
                        {log.detalhe}
                        {log.possui && (
                          <Badge
                            className="info float-right"
                            onClick={() => {
                              handleLoadJson(log.id);
                            }}
                          >
                            JSON
                          </Badge>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </>
      );
    }

    return (
      <div className="text-center">
        <small className="text-muted font-weight-bold">
          Nenhum log registrado
        </small>
      </div>
    );
  }

  return (
    <>
      <Header showCards={false} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <FormGroup className="mb-4">
              <InputGroup>
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  onClick={handleOpenModal}
                >
                  <FaPlusCircle />
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>

        <Modal
          className="modal-dialog-centered"
          size="lg"
          isOpen={isModalOpen}
          toggle={() => setIsModalOpen(!isModalOpen)}
        >
          <div className="modal-body p-0">
            <Card className="bg-secondary shadow border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <small>Nova integração</small>
                </div>
                <Form role="form">
                  <FormGroup className="mb-3">
                    <small>Tipo*</small>
                    <Select
                      options={tipos
                        .filter(item => item.podeDispararManualmente === true)
                        .map(it => ({
                          value: it.id,
                          label: `${it.id} - ${it.descricao}`,
                        }))}
                      placeholder="Selecione o tipo"
                      value={
                        novaIntegracao.tipo
                          ? {
                              value: novaIntegracao.tipo,
                              label: `${novaIntegracao.tipo} - ${
                                tipos.find(it => it.id === novaIntegracao.tipo)
                                  ?.descricao
                              }`,
                            }
                          : null
                      }
                      onChange={selected =>
                        setNovaIntegracao({
                          ...novaIntegracao,
                          tipo: selected?.value || '',
                        })
                      }
                      isClearable
                      styles={{
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        menu: provided => ({
                          ...provided,
                          backgroundColor: '#ffffff',
                          zIndex: 9999,
                        }),
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? '#f0f0f0'
                            : 'transparent',
                          color: state.isSelected ? '#000000' : '#333',
                        }),
                      }}
                    />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <small>Código Referência</small>
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-tag" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Código Referência"
                        value={novaIntegracao.origem}
                        type="text"
                        onChange={text =>
                          setNovaIntegracao({
                            ...novaIntegracao,
                            origem: text.target.value,
                          })
                        }
                      />
                    </InputGroup>
                  </FormGroup>

                  <div className="text-center">
                    <Button
                      className="my-4"
                      color="primary"
                      type="button"
                      disabled={isSaving}
                      onClick={salvar}
                    >
                      Salvar
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered"
          size="lg"
          style={{ maxWidth: '60vw', width: '100%' }}
          isOpen={modalLogVisivel}
          toggle={() => setModalLogVisivel(false)}
        >
          <ModalBody>
            <h3 className="mb-0">
              Logs da Integração #{registroLog.id} - {registroLog.tipo}
            </h3>
            <i>{`Ref. Origem: ${registroLog.origem} | Ref. Destino: ${
              registroLog.destino ?? 'Não existe nesse tipo'
            }`}</i>
            <div
              className="mt-2"
              style={{
                height: '50vh',
                overflow: 'scroll',
              }}
            >
              {DetalharLog()}
            </div>
          </ModalBody>
        </Modal>

        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col sm="9">
                    <h3 className="mb-0">Integrações</h3>
                  </Col>
                </Row>
              </CardHeader>

              {/* Filtros */}
              <Card className="shadow pt-3 pb-2 px-2 mt-1 mb-0 mx-1">
                <Row>
                  <Col sm="6">
                    <Row>
                      {/* Data início */}
                      <Col sm="6" className="mb-2">
                        <TextField
                          label="Data Início"
                          type="date"
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          value={filtros.dataInicio}
                          onChange={e =>
                            setFiltros({
                              ...filtros,
                              dataInicio: e.target.value,
                            })
                          }
                        />
                      </Col>
                      {/* Data Final */}
                      <Col sm="6" className="mb-2">
                        <TextField
                          label="Data Final"
                          type="date"
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          value={filtros.dataFim}
                          onChange={e =>
                            setFiltros({
                              ...filtros,
                              dataFim: e.target.value,
                            })
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" className="mb-2">
                        <Select
                          options={tipos.map(it => ({
                            value: it.id,
                            label: `${it.id} - ${it.descricao}`,
                          }))}
                          placeholder="Selecione o tipo"
                          value={
                            filtros.tipo
                              ? {
                                  value: filtros.tipo,
                                  label: `${filtros.tipo} - ${
                                    tipos.find(it => it.id === filtros.tipo)
                                      ?.descricao
                                  }`,
                                }
                              : null
                          }
                          onChange={selected =>
                            setFiltros({
                              ...filtros,
                              tipo: selected?.value || '',
                            })
                          }
                          isClearable
                          styles={{
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            menu: provided => ({
                              ...provided,
                              backgroundColor: '#ffffff',
                              zIndex: 9999,
                            }),
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isSelected
                                ? '#f0f0f0'
                                : 'transparent',
                              color: state.isSelected ? '#000000' : '#333',
                            }),
                          }}
                        />
                      </Col>
                      <Col sm="6" className="mb-2">
                        <Select
                          options={status.map(it => ({
                            value: it.id,
                            label: `${it.descricao}`,
                          }))}
                          placeholder="Selecione o status"
                          value={
                            filtros.status
                              ? {
                                  value: filtros.status,
                                  label: status.find(
                                    it => it.id === filtros.status,
                                  )?.descricao,
                                }
                              : null
                          }
                          onChange={selected =>
                            setFiltros({
                              ...filtros,
                              status: selected?.value || '',
                            })
                          }
                          isClearable
                          styles={{
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            menu: provided => ({
                              ...provided,
                              backgroundColor: '#ffffff',
                              zIndex: 9999,
                            }),
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isSelected
                                ? '#f0f0f0'
                                : 'transparent',
                              color: state.isSelected ? '#000000' : '#333',
                            }),
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm="6" className="mb-2">
                    <div className="float-right">
                      <Button
                        color="primary"
                        outline
                        className="me-1"
                        onClick={limparFiltros}
                      >
                        <FaEraser className="me-1" />
                      </Button>
                      <Button
                        color="primary"
                        onClick={() => buscarDados(filtros)}
                        disabled={isLoading}
                      >
                        <FaSearch className="me-1" />
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Card>

              {isLoading ? (
                <Row>
                  <Col className="text-center mb-4 mt-4">
                    <CircularProgress />
                  </Col>
                </Row>
              ) : (
                <>
                  <div
                    id="list-container"
                    style={{
                      width: '100%',
                      height: '80vh',
                      overflow: 'hidden',
                      textAlign: 'center',
                    }}
                  >
                    <AutoSizer>
                      {({ width, height }) => (
                        <Table
                          key={registros.length}
                          width={width}
                          height={height}
                          headerHeight={40}
                          rowHeight={70}
                          rowCount={registros.length}
                          rowGetter={({ index }: { index: number }) =>
                            registros[index]
                          }
                          rowStyle={{
                            borderBottom: '1px solid #ccc',
                            fontSize: '0.9rem',
                          }}
                        >
                          <Column
                            key="checkbox"
                            label=""
                            dataKey="checkbox"
                            width={100}
                            cellRenderer={({ rowData }) => {
                              return (
                                <Checkbox
                                  hidden={rowData.status === 'S'}
                                  checked={rowData.checked}
                                  onChange={(e: any) => {
                                    setRegistros(
                                      registros.map(item2 => {
                                        if (item2.id === rowData.id)
                                          return {
                                            ...item2,
                                            checked: e.target.checked,
                                          };
                                        return {
                                          ...item2,
                                        };
                                      }),
                                    );
                                  }}
                                  color="primary"
                                />
                              );
                            }}
                          />

                          <Column
                            label="#"
                            dataKey="id"
                            width={200}
                            cellRenderer={({ rowData }) => {
                              const dataGeracao = new Intl.DateTimeFormat(
                                'pt-BR',
                                {
                                  dateStyle: 'short',
                                  timeStyle: 'medium',
                                },
                              ).format(new Date(rowData.createdAt));

                              return (
                                <div>
                                  <strong>{rowData.id}</strong>
                                  <br />
                                  <small>{dataGeracao}</small>
                                </div>
                              );
                            }}
                          />

                          <Column
                            label="Tipo"
                            dataKey="tipo"
                            width={300}
                            cellRenderer={({ rowData }) => {
                              return <div>{rowData.tipo}</div>;
                            }}
                          />

                          <Column
                            label="Origem"
                            dataKey="origem"
                            width={200}
                            cellRenderer={({ rowData }) => {
                              return <div>{rowData.origem ?? ''}</div>;
                            }}
                          />

                          <Column
                            label="Tipo"
                            dataKey="tipo"
                            width={200}
                            cellRenderer={({ rowData }) => {
                              const tipoInt = rowData.status ?? 'P';

                              const integracao = status.find(
                                (it: any) => it.id === tipoInt,
                              );

                              return (
                                <Badge color={`${integracao?.color}`}>
                                  {integracao?.descricao}
                                </Badge>
                              );
                            }}
                          />

                          <Column
                            label=""
                            dataKey="log"
                            width={150}
                            cellRenderer={({ rowData }) => {
                              return (
                                <div className="float-right">
                                  <Tooltip title="Visualizar Logs">
                                    <Button
                                      size="sm"
                                      color="default"
                                      outline
                                      onClick={() => mostrarModalLog(rowData)}
                                    >
                                      <FaHistory />
                                    </Button>
                                  </Tooltip>
                                </div>
                              );
                            }}
                          />
                        </Table>
                      )}
                    </AutoSizer>
                  </div>
                </>
              )}
            </Card>
          </div>
        </Row>
        <Row className="mt-3" style={{ width: '100%' }}>
          <FloatingButton
            hidden={!registros?.filter(item => item.checked === true).length}
            className="hide-on-print"
            color="primary"
            title="Disparar integração"
            onClick={handleProcessarManualmente}
          >
            <FaCheck style={{ color: 'white' }} />
          </FloatingButton>
        </Row>
      </Container>
    </>
  );
}
